import type { GraphQLError } from 'graphql';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type {
	useGetCurrentStorageUsageQuery$data,
	useGetCurrentStorageUsageQuery$variables,
} from './__generated__/useGetCurrentStorageUsageQuery.graphql.ts';
import useGetCurrentStorageUsageQuery from './__generated__/useGetCurrentStorageUsageQuery.graphql.ts';

export const preloadStorageEnforcementBanner = (): Promise<{
	data: useGetCurrentStorageUsageQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> =>
	query<useGetCurrentStorageUsageQuery$data, useGetCurrentStorageUsageQuery$variables>({
		query: useGetCurrentStorageUsageQuery,
	});
